import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { AudienceCapacity } from 'src/app/models/audience-models/audience-capacity.model';

@Component({
  selector: 'app-audience-capacity-visitors-card',
  templateUrl: './audience-capacity-visitors-card.component.html',
  styleUrls: ['./audience-capacity-visitors-card.component.scss']
})
export class AudienceCapacityVisitorsCardComponent implements OnInit, AfterContentChecked {

  @Input() data: AudienceCapacity;
  count: string;
  percent: string;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showCounter = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('visitors-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data)) {
      this.spinnerService.hide('visitors-counts-spinner');
      this.showCounter = true;
      this.count = this.data.NumberPeopleCurrent.toString();
      this.percent = this.data.NumberPeopleComparison.toFixed(1);
    } else {
      this.count = '-';
      this.percent = '0.0';
      this.showCounter = true;
      this.spinnerService.hide('visitors-counts-spinner');
    }
  }

}
